// extracted by mini-css-extract-plugin
export default {"root":"OfferContainer_root__U5HA5","blog":"OfferContainer_blog__98EwD"};